import { fetchMetadata } from '~/fc/Dal/UtilityRepo';
import { LOCALIZED_PRICING_ROUTES_FOR_COUNTRIES } from '~/config/subscription.config'

/**
 * Initializes the pricing page locale based on the user's country.
 * 
 * - Sets the country in the Vuex store.
 * - Redirects to the localized pricing page if applicable.
 * - If the user is from a non-localized country but is on a localized route, 
 *   redirects to the default (USD) pricing page.
 * 
 * @param {Object} context - Nuxt context object.
 * @param {Object} context.$store - Vuex store instance.
 * @param {Object} context.$route - Current route object.
 * @param {Object} context.$router - Vue Router instance.
 * @returns {Promise<void>} Resolves when the locale is set and redirection is handled.
 */
export const initiatePricingPageLocale = async ({$store, $route, $router}) => {
    const metadata = await fetchMetadata()
    // const metadata = { country: 'IN' }
    if (metadata && metadata.country) $store.commit('store/setCountry', metadata.country);
    
    const countryRoute = (LOCALIZED_PRICING_ROUTES_FOR_COUNTRIES[$store.state.store.country] || '') + '/pricing';
    if (countryRoute) {
        /**
         * User is from localised country, and he is not requesting 
         * the correct route. So we are forcefully redirecting to 
         * the localised pricing page.
         */
        if (countryRoute !== $route.path) $router.push(countryRoute);
    } else {
        /**
         * User not from localised country, and he is requesting 
         * the localised route. So we are forcefully redirecting
         * to the USD pricing page.
         */
        if(Object.values(LOCALIZED_PRICING_ROUTES_FOR_COUNTRIES).some(v => $route.path.includes(v))) $router.push(307, '/pricing')
    }
}